import { Immutable } from "immer";
import React from "react";
import { DataLayerPush } from "tsi-common-react/src/components/DataLayerPush/index";
import { GASeller } from "tsi-common-react/src/components/GASeller/index";

import { templates } from "@reactivated";

import { OrderPendingBody } from "../components/OrderPendingBody";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: Immutable<templates.OrderPendingDocumentTemplate>,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <OrderPendingBody {...props} />
            <DataLayerPush events={props.ga_events} />
            <GASeller surveyData={props.ga_seller_survey_data} />
        </PageSkeleton>
    );
};
